import Box from '@redbubble/design-system/src/Box';
import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import Skeleton from '@redbubble/design-system/src/Skeleton';
import Stack from '@redbubble/design-system/src/Stack';
import Text from '@redbubble/design-system/src/Text';
import { useIntl } from '@redbubble/next/intl';
import Image from 'next/legacy/image';
import { LoadingBoundary } from '../LoadingBoundary';
import { styleSwitchMessages } from './messages';
import { useProductStyleContext } from './ProductStyleContext';
import { ProductStyleSelectorItem } from './ProductStyleSelectorItem';
import stackIcon from './stack-icon.svg';
import { openModalRequested } from './useProductStyleSwitcherState';

export const ProductStyleSelectedItem: React.FC<{}> = () => {
  const intl = useIntl();

  const {
    dispatch,
    data: { currentProductStyle },
  } = useProductStyleContext();

  if (!currentProductStyle) {
    return null;
  }

  const openModal = () =>
    openModalRequested(dispatch, currentProductStyle.gaCode);

  return (
    <Stack
      aria-labelledby="product-style-switcher-title"
      spacing="xs"
      element="section"
    >
      <Stack
        direction={constants.HORIZONTAL}
        alignItems="center"
        justifyContent="space-between"
      >
        <LoadingBoundary
          loadingComponent={
            <Box>
              <Skeleton height={28} width={90} animated />
            </Box>
          }
        >
          <Text type="display5" id="product-style-switcher-title">
            {intl.formatMessage(styleSwitchMessages.style)}
          </Text>
        </LoadingBoundary>
        <LoadingBoundary
          loadingComponent={
            <Box>
              <Skeleton height={28} width={170} animated />
            </Box>
          }
        >
          <Button
            intent={constants.PRIMARY}
            size={constants.SMALL}
            onClick={openModal}
            iconBefore={
              // {/* The stackIcon serves as a decoration rather than giving any useful info to the users,
              //     therefore it doesn't need an alt text
              // */}
              <Image
                alt=""
                layout="fixed"
                src={stackIcon}
                width={16}
                height={16}
              />
            }
          >
            {intl.formatMessage(styleSwitchMessages.exploreMore)}
          </Button>
        </LoadingBoundary>
      </Stack>

      <LoadingBoundary
        loadingComponent={
          <Box marginBottom="xs">
            <Skeleton height={86} animated />
          </Box>
        }
      >
        <ProductStyleSelectorItem
          active={false}
          description={currentProductStyle.description}
          longDescription={currentProductStyle.longDescription}
          previewImageUrl={currentProductStyle.previewImageUrl}
          matureContent={currentProductStyle.matureContent}
          onClick={openModal}
          variant="buttonStyle"
        />
      </LoadingBoundary>
    </Stack>
  );
};
